import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {TableWrapper} from 'shells/dashboard/table/table-wrapper';
// @ts-expect-error - imported from .js/.jsx file
import {SortDownIcon} from 'shells/icon/svg/sort-down-icon';
import {Link} from 'shells/link/link';

import type {GetDripSequencesDashboard_dripsDashboard_recentDrips as RecentDrip} from 'nutshell-graphql-types';

type Props = {
    dripSequences: RecentDrip[];
};

export function DripSequencesTable(props: Props) {
    const columns = React.useMemo(
        () => [
            {
                id: 'title',
                Header: 'Sequence',
                accessor: (row: RecentDrip) => row.edition,
                dataType: 'linkedName',
                width: 200,
                shouldTruncate: true,
            },
            {
                id: 'deliveryCount',
                Header: (
                    <div className='flex align-center gap-8'>
                        <SortDownIcon size={14} alignCenter={true} />
                        Deliveries
                    </div>
                ),
                accessor: (row: RecentDrip) => row.formattedDeliveries,
                dataType: 'integer',
                width: 120,
                minWidth: 120,
            },
            {
                id: 'openRate',
                Header: 'Open rate',
                accessor: (row: RecentDrip) => row.formattedOpenRate,
                dataType: 'percentage',
            },
            {
                id: 'clickRate',
                Header: 'Click rate',
                accessor: (row: RecentDrip) => row.formattedClickRate,
                dataType: 'percentage',
            },
        ],
        []
    );

    return (
        <TableWrapper
            columns={columns}
            items={props.dripSequences}
            isLoading={false}
            error={null}
            emptyStateProps={{
                title: 'Currently no active drip sequences',
                subtitle: 'Your most delivered active drip sequences will be listed here.',
                cta: (
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='button'
                        size='big'
                        to='/email-marketing/drip-sequences'
                    >
                        Create a new drip sequence
                    </Link>
                ),
            }}
        />
    );
}
